import Swal from "sweetalert2";
import * as customColors from "../../../theme/customColors";

const escapeHtml = (value) => String(value || "")
  .replace(/&/g, "&amp;")
  .replace(/</g, "&lt;")
  .replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;")
  .replace(/'/g, "&#039;");

const getLawyerNameText = (fullName) => escapeHtml(fullName);
const getLicenseNumberLine = (licenseNumber) => (
  licenseNumber
    ? `
      <div style="margin-top: 8px; color: ${customColors.darkGray}">
        מספר רישיון:
        <strong style="color: ${customColors.darkBlue}">${escapeHtml(licenseNumber)}</strong>
      </div>
    `
    : ""
);

const confirmTaxAuthorityDocumentGeneration = async ({ fullName, licenseNumber } = {}) => {
  const result = await Swal.fire({
    title: "אישור פרטי מפיק הטופס",
    html: `
      <div dir="rtl" style="text-align: right; line-height: 1.55; color: ${customColors.darkGray}; font-size: 18px">
        <div>לפני הכנת הטופס, נבקשך לוודא את פרטי המשתמש המטפל במסמכי העסקה מול רשות המסים.</div>
        <div style="margin-top: 14px; padding: 10px 14px; background: ${customColors.veryLigntGray}; border-radius: 4px">
          <div>
            שם עורך הדין:
            <strong style="color: ${customColors.darkBlue}">${getLawyerNameText(fullName)}</strong>
          </div>
          ${getLicenseNumberLine(licenseNumber)}
        </div>
        <div style="margin-top: 14px">
          חשוב לוודא כי פרטי הזיהוי המוצגים תואמים לחשבון המשתמש שבו מתבצעת הכנת המסמכים במערכת המייצגים.
        </div>
      </div>
    `,
    showCancelButton: true,
    confirmButtonColor: customColors.orange,
    cancelButtonText: "חזור לעדכון פרטים",
    confirmButtonText: "הפק טופס",
    customClass: {
      title: "tax-authority-confirm-title",
      htmlContainer: "tax-authority-confirm-content"
    },
    didOpen: () => {
      const confirmButton = Swal.getConfirmButton();
      const title = Swal.getTitle();
      if (confirmButton) {
        confirmButton.style.color = customColors.darkBlue;
      }
      if (title) {
        title.style.fontSize = "34px";
        title.style.lineHeight = "1.25";
      }
    }
  });

  return result.isConfirmed;
};

const getTaxAuthorityDocumentConfirmationKey = (dealId) => (
  dealId ? `taxAuthorityDocumentConfirmed:${dealId}` : ""
);

const getTaxAuthorityDocumentConfirmationKeys = ({ dealId, dealIds } = {}) => {
  const ids = Array.isArray(dealIds) ? dealIds : [dealId];
  return ids.map(getTaxAuthorityDocumentConfirmationKey).filter(Boolean);
};

const getSessionStorage = () => (
  typeof window !== "undefined" && window.sessionStorage ? window.sessionStorage : null
);

export const confirmTaxAuthorityDocumentGenerationOncePerDeal = async ({
  dealId,
  dealIds,
  fullName,
  licenseNumber,
  disableTaxAuthorityDocumentConfirmation = false
} = {}) => {
  if (disableTaxAuthorityDocumentConfirmation) return true;

  const confirmationKeys = getTaxAuthorityDocumentConfirmationKeys({ dealId, dealIds });
  const sessionStorage = getSessionStorage();

  if (confirmationKeys.length && sessionStorage && confirmationKeys.every((key) => sessionStorage.getItem(key) === "true")) {
    return true;
  }

  const confirmed = await confirmTaxAuthorityDocumentGeneration({ fullName, licenseNumber });
  if (confirmed && sessionStorage) {
    confirmationKeys.forEach((key) => sessionStorage.setItem(key, "true"));
  }

  return confirmed;
};
